import React from 'react';
import { cn } from '@/utils';

interface Tab {
  id: string;
  label: string;
  icon?: React.ElementType;
}

interface TabBarProps {
  tabs: Tab[];
  activeTab: string;
  onChange: (tabId: string) => void;
  className?: string;
}

export const TabBar: React.FC<TabBarProps> = ({
  tabs,
  activeTab,
  onChange,
  className = '',
}) => {
  return (
    <div className={cn("flex items-center gap-6 border-b border-slate-200 dark:border-slate-800 w-full", className)}>
      {tabs.map((tab) => {
        const isActive = activeTab === tab.id;
        const Icon = tab.icon;
        
        return (
          <button
            key={tab.id}
            type="button"
            onClick={() => onChange(tab.id)}
            className={cn(
              "flex items-center gap-2 py-3 px-1 text-[13px] font-bold transition-all relative",
              isActive 
                ? "text-slate-900 dark:text-white"
                : "text-slate-500 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-300"
            )}
          >
            {Icon && <Icon className={cn("w-4 h-4", isActive ? "text-(--primary)" : "text-slate-400")} />}
            {tab.label}
            {isActive && (
              <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-[#1e293b] dark:bg-(--primary) rounded-t-full" />
            )}
          </button>
        );
      })}
    </div>
  );
};
